import axios from 'axios'
//axios.defaults.baseURL='/api'
axios.defaults.baseURL='/fy'
import { md5 } from '@/assets/js/md5'
import { EncodeUtf8 } from '@/common/utils'


function request(config) {
  // 1.创建axios的实例
  const instance = axios.create({
    headers: {
      //'Content-Type':'multipart/form-data' //将请求体的数据处理为一条消息，以标签为单元，用分隔符分开。既可以上传键值对，也可以上传文件。
      //"Content-Type":"application/json;charset=utf-8", 请求体中的数据会以json字符串的形式发送到后端
    },
    // withCredentials : true,  发送请求时自动携带cookie
    baseURL: 'http://api.fanyi.baidu.com/api/trans/vip/translate/',
    timeout: 5000
  });

  // 3.发送真正的网络请求
  return instance(config)
}


let appid = '20220407001162410';
let key = '8nL1w5CMvRnaQIoaTt8B';
let salt = (new Date).getTime();
// 多个query可以用\n连接  如 query='apple\norange\nbanana\npear'
let from = 'zh';
let to = 'en';

export function fy(query) {
  let sign = md5(appid + query+ salt + key);
  //let queryUtf8 = encodeURIComponent(beforeQuery)  知识储备不足,卡顿半天,引以为戒
  return request({
    url: '',
    params: {
      q: query,
      from: from,
      to: to,
      appid: appid,
      salt: salt,
      sign: sign,
    }
  })
}


/*

data: {
        "from": "en",
        "to": "zh",
        "trans_result": [
            { "src": "apple", "dst": "苹果" }
        ]
      }

* */